module.exports = __webpack_public_path__ + "img/flygate-favicon.f8f9a751.png";